import { render, staticRenderFns } from "./AppBottomNavigation.vue?vue&type=template&id=4c8dea78"
import script from "./AppBottomNavigation.vue?vue&type=script&lang=js"
export * from "./AppBottomNavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports